import { render, staticRenderFns } from "./ZyOis.vue?vue&type=template&id=1e0ab965"
import script from "./ZyOis.vue?vue&type=script&lang=js"
export * from "./ZyOis.vue?vue&type=script&lang=js"
import style0 from "./ZyOis.vue?vue&type=style&index=0&id=1e0ab965&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports